// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App'
import router from './_router'
import axios from 'axios';
import wx from 'weixin-js-sdk';
import toast from './_components/public/toast/index'

// 修复ie11- promise undefined bug
window.Promise = Promise

Vue.config.productionTip = false

Vue.component('icon', require('@/_components/icon/icon'));

// const instance = axios.create({
//   baseURL: process.env.NODE_ENV !== 'production' ? 'https://sandbox-merchants.wantu.cn' : ''
// });
Vue.prototype.$http = axios;
window.wx = wx;

Vue.use(VueI18n)
Vue.use(toast)
const i18n = new VueI18n({
  locale: localStorage.lang ? localStorage.lang : 'zh-tw',
  // this.$i18n.locale 通过locale值切换语言标识
  messages: {
    'zh-cn': require('@/_components/i18n/zh'),
    'zh-tw': require('@/_components/i18n/tw'),
    'en-us': require('@/_components/i18n/en')
  }

})

if (location.hostname === 'www.fastpay.com.hk' && (location.pathname === '/' || location.pathname === '')) {
  location.href = '/fast_pay';
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js